import AppUsersService from "../services/appusers";

export const REQUEST_FAILED = "REQUEST_FAILED";

export const REQUEST_GET_APP_USERS = "REQUEST_GET_APP_USERS";
export const REQUEST_REMOVE_APP_USER = "REQUEST_REMOVE_APP_USER";
export const REQUEST_DISCHARGE_APP_USER = "REQUEST_DISCHARGE_APP_USER";
export const REQUEST_DISCHARGE_APP_USER_NO_ACCESS =
  "REQUEST_DISCHARGE_APP_USER_NO_ACCESS";
export const REQUEST_ENROLL_APP_USER = "REQUEST_ENROLL_APP_USER";
export const REFRESH_APP_USERS = "REFRESH_APP_USERS";

export const SET_SELECTED_APP_USER = "SET_SELECTED_APP_USER";
export const REQUEST_MOVE_CUSTOM_APP_TO_NEW_CHANNEL =
  "REQUEST_MOVE_CUSTOM_APP_TO_NEW_CHANNEL";

const requestFailed = (error) => ({
  type: REQUEST_FAILED,
  error,
});

const requestGetAppUsers = (userId, appId) => ({
  type: REQUEST_GET_APP_USERS,
  userId,
  appId,
});

const requestRemoveAppUser = (userId, appId, appUserId) => ({
  type: REQUEST_REMOVE_APP_USER,
  userId,
  appId,
  appUserId,
});

const requestDischargeAppUser = (userId, appId, appUserId) => ({
  type: REQUEST_DISCHARGE_APP_USER,
  userId,
  appId,
  appUserId,
});

const requestDischargeAppUserNoAccess = (userId, appId, appUserId) => ({
  type: REQUEST_DISCHARGE_APP_USER_NO_ACCESS,
  userId,
  appId,
  appUserId,
});

const requestMoveCustomAppToNewChannel = (
  userId,
  customAppId,
  patientId,
  newAppId
) => ({
  type: REQUEST_MOVE_CUSTOM_APP_TO_NEW_CHANNEL,
  userId,
  customAppId,
  patientId,
  newAppId,
});
const requestEnrollAppUser = (userId, appId, appUserId) => ({
  type: REQUEST_ENROLL_APP_USER,
  userId,
  appId,
  appUserId,
});

const refreshAppUsers = (appId, users) => ({
  type: REFRESH_APP_USERS,
  appId,
  users,
});

const setSelectedAppUser = (userId) => ({
  type: SET_SELECTED_APP_USER,
  userId,
});

export const getAppUsers = (userId, appId) => async (dispatch) => {
  dispatch(requestGetAppUsers(userId, appId));

  try {
    const result = await AppUsersService().getAppUsers(userId, appId);
    if (result && result.appId) {
      dispatch(refreshAppUsers(result.appId, result.users));
    } else {
      dispatch(requestFailed("Unable to get users of app!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const moveCustomAppToNewChannel =
  (userId, customAppId, patientId, newAppId) => async (dispatch) => {
    dispatch(
      requestMoveCustomAppToNewChannel(userId, customAppId, patientId, newAppId)
    );
    try {
      const result = await AppUsersService().moveCustomAppToNewChannel(
        userId,
        customAppId,
        patientId,
        newAppId
      );
      if (result && result.appId) {
        // dispatch(refreshAppUsers(result.appId, result.users));
      } else {
        dispatch(requestFailed("Unable to get users of app!"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const removeAppUser = (userId, appId, appUserId) => async (dispatch) => {
  dispatch(requestRemoveAppUser(userId, appId, appUserId));

  try {
    const result = await AppUsersService().removeAppUser(
      userId,
      appId,
      appUserId
    );
    if (result && result.appId) {
      dispatch(refreshAppUsers(result.appId, result.users));
    } else {
      dispatch(requestFailed("Unable to remove app user!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const dischargeAppUserNoAccess =
  (userId, appId, appUserId) => async (dispatch) => {
    dispatch(requestDischargeAppUserNoAccess(userId, appId, appUserId));

    try {
      const result = await AppUsersService().dischargeAppUserNoAccess(
        userId,
        appId,
        appUserId
      );
      if (result && result.appId) {
        dispatch(refreshAppUsers(result.appId, result.users));
      } else {
        dispatch(requestFailed("Unable to discharge app user!"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const dischargeAppUser =
  (userId, appId, appUserId) => async (dispatch) => {
    dispatch(requestDischargeAppUser(userId, appId, appUserId));

    try {
      const result = await AppUsersService().dischargeAppUser(
        userId,
        appId,
        appUserId
      );
      if (result && result.appId) {
        dispatch(refreshAppUsers(result.appId, result.users));
      } else {
        dispatch(requestFailed("Unable to discharge app user!"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const enrollAppUser = (userId, appId, appUserId) => async (dispatch) => {
  dispatch(requestEnrollAppUser(userId, appId, appUserId));

  try {
    const result = await AppUsersService().enrollAppUser(
      userId,
      appId,
      appUserId
    );
    if (result && result.appId) {
      dispatch(refreshAppUsers(result.appId, result.users));
      return result;
    } else {
      dispatch(requestFailed("Unable to remove app user!"));
      return false;
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const setCurrentAppUser = (userId) => async (dispatch) => {
  dispatch(setSelectedAppUser(userId));
};



// WEBPACK FOOTER //
// ./src/actions/appusers.js